import React, { Component } from 'react';
import { connect } from 'react-redux';
import withCurrencyConfig from '../../config/WithCurrencyConfig';
import { getJSFormattedCurrency } from '../../helpers/currency';

class Rokt extends Component {
  initialized = false; // run only once when everything is loaded - we don't care about next changes to store
  roktLauncher = null;

  componentDidUpdate() {
    const routeHash = window.location.hash;
    if (!routeHash.includes('confirmation')) {
      return;
    }

    if (this.props.data?.accountId) {
      this.run();
    }
  }

  componentWillUnmount() {
    this.roktLauncher?.terminate?.();
  }

  run() {
    if (this.initialized) {
      return;
    } else {
      this.initialized = true;
    }

    const { accountId, sandbox, identifier } = this.props.data;
    const roktLauncherElement = document.getElementById('rokt-launcher');

    return new Promise((resolve, reject) => {
      if (window.Rokt) {
        resolve();
      } else if (roktLauncherElement) {
        roktLauncherElement.onload = resolve;
      } else {
        reject("Rokt Launcher hasn't been added to the DOM. User has opted out from analytics.");
      }
    })
      .then(() =>
        window.Rokt.createLauncher({
          accountId,
          sandbox,
        }),
      )
      .then((launcherInstance) => {
        this.roktLauncher = launcherInstance;

        return this.roktLauncher.selectPlacements({
          identifier: identifier,
          attributes: { ...this.props.data.attributes },
        });
      })
      .catch((e) => {
        if (sandbox) {
          console.error(e);
        }
      });
  }

  render() {
    return null;
  }
}

const mapStateToProps = (state) => {
  return {
    data: state?.confirmation?.roktPayload,
  };
};

export const RoktPlaceholder = () => <div id="rokt-placeholder" className="rokt-placeholder" />;

export default withCurrencyConfig(connect(mapStateToProps)(Rokt));
